import React from 'react'
import AccountCreation from '../components/AccountCreation/AccountCreation'

const VuseAccountCreation = () => {
  return <AccountCreation />
}

export default VuseAccountCreation
